import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaHome, FaSignOutAlt, FaUserAlt, FaPlus, FaSearch, FaShieldAlt } from "react-icons/fa";
import { userSession } from "../observers/userObserver";
import "./Sidebar.css";
import logo from "./cod_logo.png";
import config from "../config/config";
import { useModal } from "../hooks/useModal";
import { sharedData } from "../sharedData/sharedData";
import { useRequest } from "./RequestContext";
import { useNavigate } from "react-router-dom";
import { Modal } from "./ui/Modal";
import { resetFormCache } from "../utils/resetFormCache";
const Sidebar = () => {
   const navigate = useNavigate();
  const { updateRequestId } = useRequest();
  const [userType, setUserType] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscribeModalOpen, setSubscribeModalOpen] = useState(false);
const {modalOpen, setModalOpen, modalMessage, setModalMessage, modalHeading} = useModal(false);
  // Subscribe to user type + AI search flag from session observer
  useEffect(() => {
    const unsubscribe = userSession.subscribe((user, _) => {
      console.log("User Type:", user.userType, "AI Search Enabled:", user.userAISearchEnabled);
      setUserType(user.userType?.toLowerCase()); // Ensure lowercase for consistency
      setIsSubscribed(Boolean(user.userAISearchEnabled) || user.userType?.toLowerCase() === "cod");
    });

    return () => {
      unsubscribe();
    };
  }, []);


  const handleLogout = () => {
    localStorage.clear(); // ✅ Remove everything from localStorage
    window.location.href = config['login-url'] // ✅ Redirect to login page
  };
const handleAddRequest = async () => {
    setModalMessage("Creating a new request...");
    setModalOpen(true);
    try {
      const username = localStorage.getItem("userName");
      const useremail = localStorage.getItem("userEmail");
      const token = userSession.getToken();
      const refreshToken = userSession.getRefreshToken();

      const response = await fetch(`${config["backend-url"]}/create_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (response.ok) {
        const requestId = data.request_id;
        updateRequestId(requestId);
        sharedData.clear();

        // Full reset so the previous request's "Validated" status cannot bleed into this
        // new request and lock its screens.
        resetFormCache();

        sharedData.set("requestId", requestId);

        setModalMessage("Request created successfully!");
        setModalOpen(false);
        navigate(`/transaction-detail`);
      } else {
        setModalMessage(<>
          Failed to create request
          Error: 
          <pre>{JSON.stringify(data)}</pre>
        </>);
        setModalOpen(false);
        console.error("Failed to create request", data);
      }
    } catch (error) {
      setModalMessage(<>
        Failed to create request
        Error: 
        <pre>{JSON.stringify(error)}</pre>
      </>);
      setModalOpen(false);
      console.error("Error during API call:", error);
    }
  };
  return (
    <aside className="sidebar">
      <div className="logo">
        <img src={logo} alt="Company Logo" />
      </div>
      <nav>
        <ul>
          <li>
            <Link to="/dashboard" className="sidebar-link" onClick={resetFormCache} title="Home">
              <FaHome className="home-icon" />
            </Link>
          </li>
          <li>
            <Link to="/transaction-detail" className="sidebar-link" onClick={handleAddRequest} title="Add New Request">
              <FaPlus className="home-icon" />
            </Link>
          </li>

          <li>
            <Link to="/totp-setup" className="sidebar-link" title="Set Up Authenticator App">
              <FaShieldAlt className="home-icon" />
            </Link>
          </li>

          {/* ✅ AdminUser visible only if userType is 'admn' */}
          {userType === "admn" && (
            <li>
              <Link to="/AdminUser" className="sidebar-link" title="User Management">
                <FaUserAlt className="home-icon" />
              </Link>
            </li>
          )}

          {/* ✅ CoD Admin visible only if userType is 'cod' */}
          {userType === "cod" && (
            <li>
              <Link to="/ConDAdmin" className="sidebar-link" title="COnD Admin">
                <FaUserAlt className="home-icon" />
              </Link>
            </li>
          )}

          {/* Adverse Media Search: visible to all; subscribers (company has AI Search enabled) get access, others see a grayed icon + subscribe prompt */}
          <li>
            {isSubscribed ? (
              <Link to="/AdverseSearch" className="sidebar-link" title="Adverse Media Search">
                <FaSearch className="home-icon" />
              </Link>
            ) : (
              <div
                className="sidebar-link"
                title="Adverse Media Search (subscription required)"
                onClick={() => setSubscribeModalOpen(true)}
                style={{ opacity: 0.4, cursor: "pointer" }}
              >
                <FaSearch className="home-icon" />
              </div>
            )}
          </li>
        </ul>
      </nav>

      <div className="sidebar-bottom">
        <div className="sidebar-link" onClick={handleLogout} title="Logout">
          <FaSignOutAlt className="home-icon" />
        </div>
      </div>

      {subscribeModalOpen && (
        <Modal
          modalHeading="Subscription Required"
          modalMessage="Adverse Media Search is only available to subscribers. Please contact COnD to subscribe to this service."
          onClick={() => setSubscribeModalOpen(false)}
        />
      )}
    </aside>
  );
};

export default Sidebar;
